/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var control_container_1 = require('./control_container');
var shared_1 = require('./shared');
var validators_1 = require('../validators');
exports.controlGroupProvider = {
  provide: control_container_1.ControlContainer,
  useExisting: core_1.forwardRef(function() {
    return NgControlGroup;
  })
};
var NgControlGroup = (function(_super) {
  __extends(NgControlGroup, _super);
  function NgControlGroup(parent, _validators, _asyncValidators) {
    _super.call(this);
    this._validators = _validators;
    this._asyncValidators = _asyncValidators;
    this._parent = parent;
  }
  NgControlGroup.prototype.ngOnInit = function() {
    this.formDirective.addControlGroup(this);
  };
  NgControlGroup.prototype.ngOnDestroy = function() {
    this.formDirective.removeControlGroup(this);
  };
  Object.defineProperty(NgControlGroup.prototype, "control", {
    get: function() {
      return this.formDirective.getControlGroup(this);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgControlGroup.prototype, "path", {
    get: function() {
      return shared_1.controlPath(this.name, this._parent);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgControlGroup.prototype, "formDirective", {
    get: function() {
      return this._parent.formDirective;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgControlGroup.prototype, "validator", {
    get: function() {
      return shared_1.composeValidators(this._validators);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgControlGroup.prototype, "asyncValidator", {
    get: function() {
      return shared_1.composeAsyncValidators(this._asyncValidators);
    },
    enumerable: true,
    configurable: true
  });
  NgControlGroup.decorators = [{
    type: core_1.Directive,
    args: [{
      selector: '[ngControlGroup]',
      providers: [exports.controlGroupProvider],
      inputs: ['name: ngControlGroup'],
      exportAs: 'ngForm'
    }]
  }];
  NgControlGroup.ctorParameters = [{
    type: control_container_1.ControlContainer,
    decorators: [{type: core_1.Host}, {type: core_1.SkipSelf}]
  }, {
    type: undefined,
    decorators: [{type: core_1.Optional}, {type: core_1.Self}, {
      type: core_1.Inject,
      args: [validators_1.NG_VALIDATORS]
    }]
  }, {
    type: undefined,
    decorators: [{type: core_1.Optional}, {type: core_1.Self}, {
      type: core_1.Inject,
      args: [validators_1.NG_ASYNC_VALIDATORS]
    }]
  }];
  return NgControlGroup;
}(control_container_1.ControlContainer));
exports.NgControlGroup = NgControlGroup;
